var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('inputSelect',{key:_vm.data,attrs:{"settings":{
      value: _vm.services[_vm.index].time,
      default: _vm.defaultValue,
      values: _vm.values
    },"callback":_vm.setTime,"placeholder":_vm.$t('services.duration.title'),"label":_vm.$t('services.duration.title'),"help":_vm.$t('services.duration.info')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }